import React from 'react'
import {
    List,
    ListItemPrefix,
    Avatar,
    Typography,
    IconButton,
    Popover,
    PopoverHandler,
    PopoverContent,
} from "@material-tailwind/react";

function ViewIcon() {
    return (
        <svg
            className='p-0'
            width="20px" height="20px"
            viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M9 4.45962C9.91153 4.16968 10.9104 4 12 4C16.1819 4 19.028 6.49956 20.7251 8.70433C21.575 9.80853 22 10.3606 22 12C22 13.6394 21.575 14.1915 20.7251 15.2957C19.028 17.5004 16.1819 20 12 20C7.81811 20 4.97196 17.5004 3.27489 15.2957C2.42496 14.1915 2 13.6394 2 12C2 10.3606 2.42496 9.80853 3.27489 8.70433C3.75612 8.07914 4.32973 7.43025 5 6.82137"
                stroke="#1C274C" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
                stroke="#1C274C" strokeWidth="1.5" />
        </svg>
    );
}

const TreatmentItemsList = ({ equipmentListData }) => {

    const [openPopoverId, setOpenPopoverId] = React.useState(false);

    const triggers = (id) => ({
        onClick: () => setOpenPopoverId(id),
        onMouseEnter: () => setOpenPopoverId(id),
        onMouseLeave: () => setOpenPopoverId(null),
    });

    return (
        <>
            <List className='w-full min-w-min'>
                {equipmentListData.map((listData) =>

                    <div key={listData.equipmentItemId} className='flex flex-row p-1 gap-3 rounded-md transition duration-300 hover:bg-black/10'>
                        <ListItemPrefix className='mr-0 w-12 min-w-12'>
                            <Avatar variant="circular" alt={listData.alt} src={listData.equipmentItemImage} />
                        </ListItemPrefix>

                        <div className='w-full'>
                            <div className='flex justify-between'>
                                <Typography variant="h6" color="blue-gray" className='text_OpenSans-VariableFont_wdth text-sm'>
                                    {listData.equipmentItemName}
                                </Typography>
                                <Popover open={openPopoverId === listData.equipmentItemId} handler={setOpenPopoverId}
                                    animate={{
                                        mount: { scale: 1, y: 0 },
                                        unmount: { scale: 0, y: 25 },
                                    }}
                                >
                                    <PopoverHandler  {...triggers(listData.equipmentItemId)} className='h-auto '>
                                        <IconButton variant="text" color="blue-gray">
                                            <ViewIcon />
                                        </IconButton>
                                    </PopoverHandler>
                                    <PopoverContent className='w-96 text_OpenSans-VariableFont_wdth font-light'>
                                        {listData.equipmentItemDescription}
                                    </PopoverContent>
                                </Popover>

                            </div>
                            <Typography variant="small" color="gray" className="font-normal description_AlegreyaSans-Light">
                                {listData.equipmentItemSubtitle}
                            </Typography>
                        </div>
                    </div>

                )}
            </List>
        </>
    )
}

export default TreatmentItemsList